/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2021 Priska Wermelinger & Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component, { type ComponentAttrs } from 'flarum/common/Component';
import type Mithril from 'mithril';
import type Bookshelf from '../../common/models/Bookshelf';
import BookshelfRadio from './BookshelfRadio';
import CreateBookshelfBtn from './CreateBookshelfBtn';

export interface BookshelvesRadiosAttrs extends ComponentAttrs {
	bookshelves: Bookshelf[];
	selected?: Bookshelf | null;
	setBookshelf: (bookshelf?: Bookshelf) => void;
	onCreated: (bookshelf: Bookshelf) => void;
}

export default class BookshelvesRadios<CustomAttrs extends BookshelvesRadiosAttrs = BookshelvesRadiosAttrs> extends Component<CustomAttrs> {
	view(): Mithril.Children {
		const { bookshelves, selected, setBookshelf, onCreated } = this.attrs;

		return (
			<div className="BookshelvesRadios">
				{bookshelves.map((bookshelf) => (
					<BookshelfRadio
						bookshelf={bookshelf}
						isSelected={!!selected && selected.id() === bookshelf.id()}
						setBookshelf={() => setBookshelf(bookshelf)}
					/>
				))}
				<BookshelfRadio setBookshelf={() => setBookshelf()} isSelected={!selected} />
				<CreateBookshelfBtn onCreated={onCreated} />
			</div>
		);
	}
}
